import axios from "axios";
import { useEffect, useState } from "react";
import { FaEdit, FaTimes } from "react-icons/fa";
import Swal from "sweetalert2";

function TopClientAdmin () {
  const [clientsData, setClientsData] = useState([]);

  useEffect(() => {
    getClients();
  }, []);

  const getClients = async () => {
    const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_ADMIN}/top_client`;
    
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      });

      setClientsData(response.data.data.client);
    } catch (error) {
      console.error(error);
    }
  }

  const createUser = async () => {
    try {
      const result = await Swal.fire({
        title: "Crear Usuario",
        html:
          '<div class="form-grid">' +
          '<input type="text" id="customer_name" class="swal2-input" placeholder="nombre cliente">' +
          '<input type="text" id="consigne_name" class="swal2-input" placeholder="Nombre consignatario">' +
          '<input type="text" id="description" class="swal2-input" placeholder="Informacion del contenedor">' +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Crear",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
          const customer_name = document.getElementById("customer_name").value.trim();
          const consigne_name = document.getElementById("consigne_name").value.trim();
          const description = document.getElementById("description").value.trim();

          if (!customer_name || !consigne_name || !description) {
            Swal.showValidationMessage("⚠️ Todos los campos son obligatorios");
            return false;
          }

          return {
            customer_name,
            consigne_name,
            description,
          };

        },
      });

      if(result.isConfirmed) {
        const body = result.value;
        const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_ADMIN}/top_client/create`;

        await axios.post(url, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
        });

        Swal.fire({
          title: "Usuario creado existosamente",
          icon: "success",
          confirmButtonColor: "#3085d6",
        });
      }

      await getClients();
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error al crear usuario",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
    }
  }

  const updateClient = async (client) => {
    try {
      const result = await Swal.fire({
        title: "Editar Usuario",
        html:
          '<div class="form-grid">' +
          `<input type="text" id="customer_name" class="swal2-input" placeholder="nombre cliente" value="${client.customer_name || ''}">` +
          `<input type="text" id="consigne_name" class="swal2-input" placeholder="Nombre consignatario" value="${client.consigne_name || ''}">` +
          `<input type="text" id="description" class="swal2-input" placeholder="Informacion del contenedor" value="${client.description || ''}">` +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
          const customer_name = document.getElementById("customer_name").value.trim();
          const consigne_name = document.getElementById("consigne_name").value.trim();
          const description = document.getElementById("description").value.trim();

          if (!customer_name || !consigne_name || !description) {
            Swal.showValidationMessage("⚠️ Todos los campos son obligatorios");
            return false;
          }

          return {
            customer_name,
            consigne_name,
            description,
          };

        },
      });

      if(result.isConfirmed) {
        const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_ADMIN}/top_client/${client.id}`;
        const body = result.value;

        await axios.put(url, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
        });

        Swal.fire({
          title: "Usuario actualizado existosamente",
          icon: "success",
          confirmButtonColor: "#3085d6",
        });
      }
      
      await getClients();
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error al editar usuario",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
    }
  }

  const deleteClient = async (id) => {
    const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_ADMIN}/top_client/${id}`;
    try {
      const result = await Swal.fire({
        title: "Estas seguro de eliminar este usuario?",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#3085d6",
      });

      if(result.isConfirmed) {
        await axios.delete(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
        });

        Swal.fire({
          title: "Usuario eliminado existosamente",
          icon: "success",
          confirmButtonColor: "#3085d6",
        });
      }
      await getClients();
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error al eliminar usuario",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
    }
  }

  return(
    <>
      <div className="panel-table">
        <div className='colum-left'></div>
        <div className='colum-rigth'>
          <button className="btnn" onClick={createUser}>
            Crear Usuario
          </button>
        </div>
      </div>
      <div className='table-responsive'>
        <table className='table table-preve'>
          <thead>
            <tr>
              <th>Nombre del cliente</th>
              <th>Nombre del consignatario</th>
              <th>Información del contenedor</th>
              <td className='accions'>Acciones</td>
            </tr>
          </thead>

          <tbody>
            {clientsData.map((client, index) => (
              <tr key={index}>
                <td>{ client.customer_name }</td>
                <td>{ client.consigne_name }</td>
                <td>{ client.description ? client.description : "" }</td>
                <td>
                  <FaEdit className='editButton' onClick={() => {updateClient(client)}} />
                  <FaTimes className='deleteButton' onClick={() => deleteClient(client.id)} />
                  </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
};

export default TopClientAdmin;